export default {
  computed: {
    recentJobs() {
      return Object.values(this.$beet.jobs).toSorted(
        (a, b) => new Date(b.published_at) - new Date(a.published_at),
      )
    },
  },
}
